export default __webpack_public_path__ + "static/media/place-type-loading.a1fa685d.svg";